/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainSettingsUnityOptions } from './FxIdDomainSettingsUnityOptions';
import {
    instanceOfFxIdDomainSettingsUnityOptions,
    FxIdDomainSettingsUnityOptionsFromJSON,
    FxIdDomainSettingsUnityOptionsFromJSONTyped,
    FxIdDomainSettingsUnityOptionsToJSON,
} from './FxIdDomainSettingsUnityOptions';

/**
 * @type FxIdDomainSettingsPublicWebClientConfigOptionsUnity
 * Настройки для встаивания Unity игры
 * @export
 */
export type FxIdDomainSettingsPublicWebClientConfigOptionsUnity = FxIdDomainSettingsUnityOptions;

export function FxIdDomainSettingsPublicWebClientConfigOptionsUnityFromJSON(json: any): FxIdDomainSettingsPublicWebClientConfigOptionsUnity {
    return FxIdDomainSettingsPublicWebClientConfigOptionsUnityFromJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsUnityFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsPublicWebClientConfigOptionsUnity {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsUnityOptions(json)) {
        return FxIdDomainSettingsUnityOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsUnityToJSON(json: any): any {
    return FxIdDomainSettingsPublicWebClientConfigOptionsUnityToJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsUnityToJSONTyped(value?: FxIdDomainSettingsPublicWebClientConfigOptionsUnity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainSettingsUnityOptions(value)) {
        return FxIdDomainSettingsUnityOptionsToJSON(value as FxIdDomainSettingsUnityOptions);
    }

    return {};
}

